import { useLayoutEffect, useState } from "react";

/**
 * Evita flashes de contenido durante cargas muy breves sin agregar una demora
 * extra cuando la operación real supera el mínimo visual.
 */
export function useMinimumLoading(
  isLoading,
  { minimumMs = 900, resetKey = "initial" } = {},
) {
  const [minimumElapsed, setMinimumElapsed] = useState(false);

  useLayoutEffect(() => {
    setMinimumElapsed(false);
    const timer = window.setTimeout(() => setMinimumElapsed(true), minimumMs);
    return () => window.clearTimeout(timer);
  }, [minimumMs, resetKey]);

  return Boolean(isLoading) || !minimumElapsed;
}
